export default __webpack_public_path__ + "cf466f968888c40d0123e104e654b3d2.png";